import {
  white,
  spacer8,
  spacer12,
  spacer32,
  spacer40,
  spacer48,
  gray15,
} from '@spotify-internal/encore-foundation';
import { TransitionStatus } from 'react-transition-group/Transition';

import styled, { css } from 'styled-components';

import { isDarkTheme, snackbarTransitionDuration } from './';

type ContainerProps = {
  theme: { snackbar?: 'dark' };
  state: TransitionStatus;
};

export const Container = styled.div<ContainerProps>`
  ${({ state, theme }) => css`
    background: ${isDarkTheme(theme) ? gray15 : white};
    border: 1px solid
      ${isDarkTheme(theme) ? `rgba(0, 0, 0, 0.02)` : `rgba(0, 0, 0, 0.05)`};
    border-radius: ${spacer8};
    box-shadow: 0 6px 18px 0
      ${isDarkTheme(theme) ? `rgba(0, 0, 0, 0.4)` : `rgba(0, 0, 0, 0.1)`};
    cursor: default;
    padding: ${spacer12} ${spacer32};
    text-align: center;
    max-width: 384px;
    position: fixed;
    bottom: ${spacer48};
    left: 50%;
    overflow-x: hidden;
    text-overflow: ellipsis;
    transform: translate(-50%);
    z-index: 1050; /* Sourced from services/artists/src/shared/styles/variables.js */
    transition-duration: ${snackbarTransitionDuration}ms;
    transition-timing-function: ease-out;

    ${state === 'entering' &&
    css`
      opacity: 0;
      transform: translate(-50%, ${spacer40});
    `};

    ${state === 'entered' &&
    css`
      opacity: 1;
    `};

    ${state === 'exiting' &&
    css`
      opacity: 0;
      transition-timing-function: linear;
    `};
  `}
`;
